module.exports = __webpack_public_path__ + "img/close.ec310750.svg";